import React from 'react';
import {CompositeDecorator, Editor, EditorState, RichUtils} from 'draft-js';
import {stateToHTML} from 'draft-js-export-html';
import {stateFromHTML} from 'draft-js-import-html';
import BlockStyleControls from './BlockStyleControls';
import InlineStyleControls from './InlineStyleControls';

import '../../../../node_modules/draft-js/dist/Draft.css';
import './RichTextEditor.css';
import LinkStyleControls from "./LinkStyleControls";

class RichTextEditor extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      editorState: props.defaultValue
        ? EditorState.createWithContent(stateFromHTML(props.defaultValue))
        : EditorState.createEmpty(new CompositeDecorator([
          {
            strategy: this.findLinkEntities,
            component: (props) => {
              const {url} = props.contentState.getEntity(props.entityKey).getData();
              return (
                <a href={url} className={"Foo"}>
                  {props.children}
                </a>
              );
            },
          },
        ])),
    };

    this.onChange = (editorState) => {
      let html = stateToHTML(editorState.getCurrentContent());
      this.props.onChange(html);
      this.setState({editorState})
    };
  }

  findLinkEntities = (contentBlock, callback, contentState) => {
    contentBlock.findEntityRanges(
      (character) => {
        const entityKey = character.getEntity();
        return (
          entityKey !== null &&
          contentState.getEntity(entityKey).getType() === 'LINK'
        );
      },
      callback
    );
  }

  handleKeyCommand = (command) => {
    const {editorState} = this.state;
    const newState = RichUtils.handleKeyCommand(editorState, command);
    if (newState) {
      this.onChange(newState);
      return true;
    }
    return false;
  };

  toggleBlockType = (blockType) => {
    this.onChange(
      RichUtils.toggleBlockType(
        this.state.editorState,
        blockType
      )
    );
  };


  toggleBlockType = (blockType) => {
    this.onChange(
      RichUtils.toggleBlockType(
        this.state.editorState,
        blockType
      )
    );
  };

  toggleInlineStyle = (inlineStyle) => {
    this.onChange(
      RichUtils.toggleInlineStyle(
        this.state.editorState,
        inlineStyle
      )
    );
  };

  toggleLinkType = (blockType) => {
    const {editorState} = this.state;
    var selectionState = editorState.getSelection();

    if (RichUtils.currentBlockContainsLink(editorState)) {
      this.onChange(
        RichUtils.toggleLink(
          editorState,
          selectionState,
          null
        )
      );
      return;
    }

    var anchorKey = selectionState.getAnchorKey();
    var currentContent = editorState.getCurrentContent();
    var currentContentBlock = currentContent.getBlockForKey(anchorKey);
    var start = selectionState.getStartOffset();
    var end = selectionState.getEndOffset();
    var selectedText = currentContentBlock.getText().slice(start, end);

    const contentStateWithEntity = currentContent.createEntity(
      blockType,
      'MUTABLE',
      {url: selectedText.match(/^(http:\/\/|https:\/\/).*/g)? selectedText : 'http://' + selectedText}
    );
    const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
    const newEditorState = EditorState.set(editorState, { currentContent: contentStateWithEntity });

    this.onChange(
      RichUtils.toggleLink(
        newEditorState,
        newEditorState.getSelection(),
        entityKey
      )
    );
  };

  render() {
    const { placeholder } = this.props;
    const { editorState } = this.state;

    return (
      <div className="RichEditor-root">
        <BlockStyleControls
          editorState={editorState}
          onToggle={this.toggleBlockType}
        />
        <InlineStyleControls
          editorState={editorState}
          onToggle={this.toggleInlineStyle}
        />
        <LinkStyleControls
          editorState={editorState}
          onToggle={this.toggleLinkType}
        />
        <div className="RichEditor-editor">
          <Editor
            editorState={editorState}
            onChange={this.onChange}
            handleKeyCommand={this.handleKeyCommand}
            placeholder={placeholder || 'Type your text here...'}
          />
        </div>
      </div>
    );
  }
}

export default RichTextEditor;
